import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Observable, timeout } from 'rxjs';
import { MyDialogService } from 'src/app/shared/utils/my-dialog.service';
import { environment } from 'src/environments/environment';
import { ApiErrorMessageService } from '../services/auth/api-error-message.service';
import { LoaderService } from './loader.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private dialogService: MyDialogService,
    private apiErrorMessgeService: ApiErrorMessageService,
    private translateService: TranslateService
  ) { }

  private handleError(error: any) {    
    console.log('error :',error)
    if (error.error) {
      const customMessage = this.apiErrorMessgeService.getErrorText(error.error);
      this.dialogService.warningTitle(customMessage);
    }
    if(error.status == 503){
      this.dialogService.warningTitle(this.translateService.instant('SERVER.NOT_READY'));
    }
  }

  private async execute<T>(func: Observable<T>, showLoading: boolean = true): Promise<T | null> {
    try {
      this.showLoading(showLoading);
      const result = await firstValueFrom(func);
      this.hideLoading(showLoading);
      return result;
    } catch (error) {
      this.hideLoading(showLoading);
      this.handleError(error);
      return null;
    }
  }
  private showLoading(showLoading: boolean) {
    if (showLoading) {
      this.loaderService.enable();
    }
  }
  private hideLoading(showLoading: boolean) {
    if (showLoading) {
      this.loaderService.disable();
    }
  }

  async get<T>(path: string, params: any = {}, showLoading: boolean = true): Promise<T | null> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => httpParams = httpParams.append(key, params[key]));
    const result = await this.execute(this.http.get<T>(`${environment.apiUrl}${path}`, { params: httpParams }), showLoading);
    return result;
  }

  async put<T>(path: string, body: object = {}, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.put<T>(`${environment.apiUrl}${path}`, body), showLoading);
    return result;
  } 

  async post<T>(path: string, body: object = {}, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.post<T>(`${environment.apiUrl}${path}`, body).pipe(timeout(180*1000)), showLoading);
    return result;
  }


  async search_complete<T>(path: string, body: object = {}, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.post<T>(`${environment.apiUrl}${path}`, body), showLoading);
    return result;
  }

  async postFormData<T>(path: string, body: FormData, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.post<T>(`${environment.apiUrl}${path}`, body), showLoading);
    return result;

  }

  async patch<T>(path: string, body: object = {}, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.patch<T>(`${environment.apiUrl}${path}`, body), showLoading);
    return result;
  }

  async delete<T>(path: string, body: object = {}, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.delete<T>(`${environment.apiUrl}${path}`), showLoading);
    return result;
  }

  async getNotiSystemm<T>(path: string, params: any = {}, showLoading: boolean = true): Promise<T | null> {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => httpParams = httpParams.append(key, params[key]));
    const result = await this.execute(this.http.get<T>(`${environment.apiNotiSystemUrl}${path}`, { params: httpParams }), showLoading);
    return result;
  }

  async patchNotiSystemm<T>(path: string, body: object = {}, showLoading: boolean = true): Promise<T | null> {
    const result = await this.execute(this.http.patch<T>(`${environment.apiNotiSystemUrl}${path}`, body), showLoading);
    return result;
  }
}
